import { classnames } from 'helpers/utils';
import { ComputerMark, DriveMark, DropboxMark, IcloudMark } from './marks';
import styles from './import-source-tiles.module.scss';

// Kept in sync with the `?source=` param the import page reads to jump
// straight to the matching step.
export type ImportSourceKey = 'computer' | 'drive' | 'dropbox' | 'icloud';

interface ImportSourceTilesProps {
  onSelect: (source: ImportSourceKey) => void;
  className?: string;
}

const SOURCES: {
  key: ImportSourceKey;
  title: string;
  subtitle: string;
  badge?: string;
  mark: React.ReactNode;
  iconClass: string;
}[] = [
  {
    key: 'computer',
    title: 'Your Computer',
    subtitle: 'Pick a folder — subfolders become albums',
    mark: <ComputerMark />,
    iconClass: styles.iconComputer,
  },
  {
    key: 'drive',
    title: 'Google Drive',
    subtitle: 'Pick files from your Drive',
    mark: <DriveMark />,
    iconClass: styles.iconDrive,
  },
  {
    key: 'dropbox',
    title: 'Dropbox',
    subtitle: 'Import Dropbox folders as albums',
    mark: <DropboxMark />,
    iconClass: styles.iconDropbox,
  },
  {
    key: 'icloud',
    title: 'iCloud',
    subtitle: 'Paste a Shared Album link',
    badge: 'From iPhone',
    mark: <IcloudMark />,
    iconClass: styles.iconIcloud,
  },
];

// The four bulk-import sources, laid out as a compact row. Shares the card
// treatment used on the full import page.
export const ImportSourceTiles = ({
  onSelect,
  className = '',
}: ImportSourceTilesProps) => (
  <div className={classnames(styles.grid, className)}>
    {SOURCES.map((source, index) => (
      <button
        key={source.key}
        type="button"
        className={styles.card}
        style={{ animationDelay: `${index * 70}ms` }}
        onClick={() => onSelect(source.key)}
      >
        {source.badge && <span className={styles.badge}>{source.badge}</span>}
        <span className={classnames(styles.icon, source.iconClass)} aria-hidden>
          {source.mark}
        </span>
        <span className={styles.title}>{source.title}</span>
        <span className={styles.subtitle}>{source.subtitle}</span>
      </button>
    ))}
  </div>
);
